import React from 'react';

/**
 * 멤버십 가입 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const MembershipSignupProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '멤버십 가입신청'
      },
      {
        name: 'componentProps.description',
        label: '설명',
        control: 'TextField',
        multiline: true,
        rows: 3,
        defaultValue: '멤버십에 가입하시면 다양한 혜택을 받으실 수 있습니다.'
      },
      {
        name: 'componentProps.productId',
        label: '상품 ID',
        control: 'TextField',
        type: 'number',
        defaultValue: 0,
        helperText: '가입할 멤버십 상품의 ID를 입력하세요'
      },
      {
        name: 'componentProps.buttonText',
        label: '버튼 텍스트',
        control: 'TextField',
        defaultValue: '가입 신청'
      },
      {
        name: 'componentProps.completedText',
        label: '완료 텍스트',
        control: 'TextField',
        defaultValue: '가입 완료'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#f9f9f9'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '40px 20px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      }
    ]
  },
  {
    group: '버튼 스타일',
    properties: [
      {
        name: 'buttonStyle.backgroundColor',
        label: '버튼 배경색',
        control: 'ColorPicker',
        defaultValue: '#ff3f6c'
      },
      {
        name: 'buttonStyle.color',
        label: '버튼 텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'buttonStyle.borderRadius',
        label: '버튼 테두리 둥글기',
        control: 'TextField',
        defaultValue: '4px'
      }
    ]
  }
];

export default MembershipSignupProperties; 